// Single source of truth for class-type colours — previously redefined 4 times
// (Classes.jsx had two disagreeing copies in the same file, MySchedule.jsx, DemoView.jsx)
// with "Morning" drifting between amber, yellow and orange, and "Evening" drifting
// between blue and indigo. Standardised on yellow/blue (2 of 3 modern copies already
// agreed) — amber was avoided since Pass 1 now reserves it for the warning tier, and a
// neutral category tag using the same colour as "needs attention" would be confusing.
//
// "Special" was bg-primary-light/text-primary in 3 of 4 copies — but that's brand red on
// a neutral category tag with no more urgency than "Morning", the same misuse Pass 1
// fixed elsewhere (bg-primary/10 reserved for actual emphasis/action, never neutral info).
// Moved to the plain neutral badge treatment instead — no new colour introduced.
//
// Two variants: PILL for compact badges (bg-100/text-700, no border), CARD for the
// bordered schedule-grid cards (bg-50/border-100/text-800).
export const CLASS_TYPE_PILL = {
  Morning: 'bg-yellow-100 text-yellow-700',
  Evening: 'bg-blue-100 text-blue-700',
  Weekend: 'bg-purple-100 text-purple-700',
  Special: 'bg-nav-hover text-secondary',
};

export const CLASS_TYPE_CARD = {
  Morning: 'bg-yellow-50 border-yellow-100 text-yellow-800',
  Evening: 'bg-blue-50 border-blue-100 text-blue-800',
  Weekend: 'bg-purple-50 border-purple-100 text-purple-800',
  Special: 'bg-nav-hover border-divider text-secondary',
};
